<!-- #154 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Package Details
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="getTableHeaders()"
      :items="order"
      :options.sync="options"
      :server-items-length="total"
      :search="search"
      :loading="orderLoader"
      class="elevation-1 mt-7 mr-4"
      :items-per-page="25"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  v-model="client_name"
                  label="Client Name"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  chips
                  small-chips
                  clearable
                  @click:clear="clearInput('client_name')"
                  @focus="getClientList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-model="tracking_number"
                  label="Tracking No."
                  outlined
                  clearable
                  @click:clear="clearInput('tracking_number')"
                  class="heights"
                  height="10px"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-model="order_reference"
                  label="Order Reference"
                  outlined
                  @click:clear="clearInput('order_reference')"
                  clearable
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  v-model="carrier_name"
                  :items="carriers"
                  outlined
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="name"
                  @focus="fetchCarriers"
                  label="Carrier Name"
                  @click:clear="clearInput('carrier_name')"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="serviceType"
                  :items="servicesCodes"
                  outlined
                  dense
                  chips
                  :item-text="
                    (item) => `${item.service_name} - (${item.service_code})`
                  "
                  item-value="service_code"
                  small-chips
                  label="Service Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="selectedStatus"
                  :items="allStatus"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Status"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="deliveryType"
                  :items="deliveryTypes"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Delivery Type"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="dutyhandling"
                  :items="dutyhandlings"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Duty Handling"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="origin_country"
                  :items="countries"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Origin Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="destination_country"
                  :items="countries"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Destination Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      placeholder="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      placeholder="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                :sm="userCategory.user_category === 3 ? '' : '6'"
              >
                <v-btn
                  color="white v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mt-2 mb-2"></v-divider>
          </v-form>
        </template>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          @click="download(item.tracking_no)"
          small
          v-if="item.status == 'post'"
        >
          mdi-download
        </v-icon>
        <v-icon
          small
          @click="downloadSingleInvoice(item.tracking_no)"
          v-if="
            item.download_invoice == 'yes' &&
            checkPermission('app_consignment_order:download_shipping_invoice')
          "
        >
          mdi-receipt
        </v-icon>

        <v-icon
          @click="syncOrder(item)"
          v-if="
            item.status_display == 'Exceptions' &&
            userCategory.user_category === 3 &&
            checkPermission('app_consignment_order:consignment_order_assign') &&
            checkLastDay(item.created_at)
          "
        >
          mdi-sync
        </v-icon>
      </template>
      <template v-slot:[`item.client`]="{ item }">
        {{ item.client.name }}
      </template>
      <template v-slot:[`item.duty_handling`]="{ item }">
        {{ item.duty_handling ? item.duty_handling.toUpperCase() : "" }}
      </template>

      <template v-slot:[`item.total_value`]="{ item }">
        {{ item.total_value }} {{ item.total_value_currency }}
      </template>
      <template v-slot:[`item.order_value`]="{ item }">
        <label v-if="item.order_value !== null">
          {{ item.order_value }} {{ item.order_currency_code }}
        </label>
        <label v-else>--</label>
      </template>

      <template v-slot:[`item.package_weight`]="{ item }">
        {{ item.package_weight }} kg
      </template>
      <template v-slot:[`item.tracking_no`]="{ item }">
        <label @click="fetchTrackingDetails(item)">
          <a>{{ item.tracking_no }}</a>
        </label>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">{{
          item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span>
        <span v-else>--</span>
      </template>
      <template v-slot:[`item.carrier_status_updated_at`]="{ item }">
        <span v-if="item.carrier_status_updated_at">{{
          item.carrier_status_updated_at
            | localMoment
            | moment("DD MMM, YYYY hh:mm A")
        }}</span
        ><span v-else>--</span>
      </template>

      <template v-slot:[`item.delivery_type`]="{ item }">
        <span v-if="item.delivery_type">{{
          capitalizeFirstLetter(item.delivery_type)
        }}</span>
        <span v-if="item.service_type"
          >({{ item.service_name }}-{{ item.service_type }})</span
        >
      </template>
      <template v-slot:[`item.status_display`]="{ item }">
        <span
          v-if="item.status_display == 'Exceptions'"
          @click="exceptionFunc(item)"
        >
          <a>{{ item.status_display }} </a>
        </span>
        <span
          v-else-if="item.status_display == 'Delivered' && item.pod_doc == true"
          @click="deliveredFunc(item)"
        >
          <a>{{ item.status_display }} </a>
        </span>
        <span v-else>{{ item.status_display }}</span>
      </template>
    </v-data-table>

    <template>
      <div class="text-center">
        <v-dialog v-model="message" width="auto">
          <template>
            <v-card class="mx-auto p-6" width="500" variant="outlined">
              <v-card-item>
                <div class="title">
                  <div class="text-h6 mb-1">Error Message</div>

                  <div class="text-caption">
                    <b> {{ orderRef }} - </b> {{ message_text }}
                  </div>
                </div>
              </v-card-item>

              <v-card-actions>
                <v-btn
                  variant="outlined"
                  color="primary"
                  @click="message = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <!-- <v-card>
            <template v-slot:title> This is a title </template>
            <v-card-text class="pt-4">
              {{ message_text }}
            </v-card-text>

            <v-card-actions class="">
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <v-btn color="primary" @click="message = false">Close</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card> -->
        </v-dialog>
      </div>
    </template>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <podData :list="podList" @close="close" />
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import podData from "@/components/front/pod-data";
export default {
  components: {
    podData,
  },
  data: () => ({
    serviceType: null,
    dialog: false,
    podList: [],
    orderRef: "",
    message: false,
    message_text: "",
    dialogDelete: false,
    searchType: null,
    client_name: "",
    tracking_number: "",
    order_reference: "",
    destination_country: "",
    origin_country: "",
    from_date: "",
    to_date: "",
    selectedStatus: "",
    carrier_name: "",
    countries: [],
    carriers: [],
    allStatus: [
      {
        text: "Created",
        value: "draft",
      },
      {
        text: "In Planning",
        value: "planning",
      },
      {
        text: "Exceptions",
        value: "exception",
      },
      {
        text: "Movement Planned",
        value: "planned",
      },
      {
        text: "LMC-In Transit",
        value: "post",
      },
      {
        text: "In Transit",
        value: "in_transit",
      },
      {
        text: "In Transit",
        value: "in_transit",
      },
      {
        text: "Delivered",
        value: "delivered",
      },
    ],
    searchOptions: [
      {
        text: "Client Name",
        value: "client",
      },
      {
        text: "RSA Tracking No.",
        value: "tracking_id",
      },
      {
        text: "Order Ref.",
        value: "order_reference",
      },
      {
        text: "Origin Country",
        value: "origin_country",
      },
      {
        text: "Destination country",
        value: "destination_country",
      },
    ],
    dutyhandlings: [
      {
        text: "DDU",
        value: "ddu",
      },
      {
        text: "DDP",
        value: "ddp",
      },
    ],
    deliveryTypes: [
      {
        text: "Crossborder",
        value: "crossborder",
      },
      {
        text: "Domestic",
        value: "domestic",
      },
    ],
    dutyhandling: null,
    deliveryType: null,
    order: [],
    options: {},
    total: 1,
    orderLoader: false,
    editedIndex: -1,
    search: "",
    deleteLoader: false,
    _timerId: null,
    dateMenuTo: false,
    dateMenu: false,
    filtersArr: {},
    clients: [],
    servicesCodes: [],
  }),
  computed: {
    ...mapGetters(["userCategory", "userRole"]),
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    options: {
      handler() {
        this.fetchOrderDetails();
      },
      deep: true,
    },
    search() {
      this.fetchOrderDetails();
    },
    searchType() {
      if (this.search) this.fetchOrderDetails();
    },
  },
  mounted() {
    this.getCityList();
    this.getClientList();
  },
  created() {
    this.fetchCarriers();
    this.getRSAServiceListOnly().then((res) => {
      this.servicesCodes = res.data;
    });
  },
  methods: {
    isDateWithinLast5Days(dateString) {
      const currentDate = new Date();
      const inputDate = new Date(dateString);

      // Calculate the date 5 days ago
      const fiveDaysAgo = new Date();
      fiveDaysAgo.setDate(currentDate.getDate() - 5);

      return inputDate >= fiveDaysAgo;
    },
    checkLastDay(dateString) {
      let result = this.isDateWithinLast5Days(dateString);

      if (result) {
        return true;
      } else {
        return false;
      }
    },
    getClientList() {
      if (this.userCategory.user_category === 3 && this.clients.length == 0)
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "clickdna,fulfillment_wid_last_mile",
        }).then((res) => {
          this.clients = res.data;
        });
    },
    getTableHeaders() {
      let headers = [
        {
          text: "Actions",
          value: "actions",
          class: "body-1 font-weight-bold",
          width: "50px",
          sortable: false,
        },
        {
          text: "Client Name",
          value: "client_name",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Origin Country",
          value: "origin_country",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Destination Country",
          value: "destination_country",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Tracking no",
          value: "tracking_no",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Order Ref.",
          value: "order_reference",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Payment Mode",
          value: "payment_type",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "COD Amount",
          value: "total_value",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Order Value",
          value: "order_value",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Delivery Type",
          value: "delivery_type",
          class: "body-1 font-weight-bold",
          sortable: false,
          width: "200px",
        },
        {
          text: "Duty Handling",
          value: "duty_handling",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Status",
          value: "status_display",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Total Pieces",
          value: "total_pieces",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Package weight",
          value: "package_weight",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Carrier",
          value: "carrier",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Carrier Status",
          value: "carrier_status",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "RSA Status",
          value: "rsa_event",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Carrier Status Updated at",
          value: "carrier_status_updated_at",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Created at (UTC)",
          value: "created_at",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ];
      if (this.userCategory.user_category !== 3) {
        const index = headers.findIndex((e) => {
          return e.value == "carrier";
        });
        if (index > -1) {
          // only splice array when item is found
          headers.splice(index, 1); // 2nd parameter means remove one item only
        }
      }

      return headers;
    },

    ...mapActions([
      "getOrderDetails",
      "downloadPackageDetails",
      "statusDisplay",
      "getCountries",
      "fetchClient",
      "getPODDetails",
      "getCarriersDropdown",
      "syncOrders",
      "snackBar",
      "getRSAServiceListOnly",
      "downloadSingleInvoiceApi",
    ]),
    syncOrder(item) {
      this.syncOrders(item.order_id).then((res) => {
        if (res.data.status == "assigned_Successfully") {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
        } else {
          this.snackBar({
            color: "error",
            message: res.data.message,
          });
        }

        this.fetchOrderDetails();
      });
    },
    getCityList() {
      this.getCountries().then((res) => {
        res.data.forEach((e) => {
          return this.countries.push(e.name);
        });
      });
    },

    fetchCarriers() {
      if (this.userCategory.user_category === 3 && this.carriers.length == 0)
        this.getCarriersDropdown({
          pagination: 0,
          active: "all",
        })
          .then((res) => {
            this.carriers = res.data;
          })
          .catch(() => {
            this.loader = false;
          });
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.client_name,
        origin_country: this.origin_country,
        destination_country: this.destination_country,
        tracking_number: this.tracking_number,
        from_date: this.from_date,
        to_date: this.to_date,
        status: this.selectedStatus,
        carrier_name: this.carrier_name,
        order_reference: this.order_reference,
        delivery_type: this.deliveryType,
        duty_handling: this.dutyhandling,
        service_type: this.serviceType,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.options.page = 1;
      await this.allFilters();
      await this.getOrderDetails({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.order = res.data.records;
          this.total = res.data.total;
          this.orderLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    clearAll() {
      (this.client_name = ""),
        (this.origin_country = ""),
        (this.destination_country = ""),
        (this.tracking_number = ""),
        (this.from_date = ""),
        (this.to_date = ""),
        (this.selectedStatus = ""),
        (this.carrier_name = ""),
        (this.order_reference = "");
      this.deliveryType = "";
      this.dutyhandling = "";
      this.serviceType = null;
      this.searchAll();
    },
    fetchOrderDetails() {
      this.allFilters();
      this.orderDetails = [];
      this.orderLoader = true;
      this.getOrderDetails({
        ...this.options,
        ...this.filtersArr,
        search: this.search,
        type: this.searchType,
      })
        .then((res) => {
          this.order = res.data.records;
          this.total = res.data.total;
          this.orderLoader = false;
        })
        .catch(() => {
          this.orderLoader = false;
        });
    },
    fetchTrackingDetails(item) {
      window.open(
        this.$router.resolve({
          name: "ClientTrackingDetails",
          query: {
            id: item.tracking_no,
          },
        }).href,
        "_blank"
      );
    },
    download(id) {
      this.packagesLoader = true;
      this.downloadPackageDetails(id)
        .then((res) => {
          this.fileDownload(res);
          this.packagesLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    downloadSingleInvoice(id) {
      this.packagesLoader = true;
      let payload = { tracking_no: id };
      this.downloadSingleInvoiceApi(payload)
        .then((res) => {
          this.fileDownload(res);
          this.packagesLoader = false;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    exceptionFunc(item) {
      this.message_text = "";
      this.statusDisplay(item.order_id).then((res) => {
        this.message = true;
        this.orderRef = item.order_reference;
        this.message_text = res[0]["message"] + " - " + res[0]["name"];
      });
    },
    clearInput(val) {
      if (val == "from_date") {
        this.from_date = "";
      } else if (val == "to_date") {
        this.to_date = "";
      } else if (val == "client_name") {
        this.client_name = "";
      } else if (val == "order_reference") {
        this.order_reference = "";
      } else if (val == "tracking_number") {
        this.tracking_number;
      } else if (val == "carrier_name") {
        this.carrier_name = "";
      }
    },
    deliveredFunc(item) {
      if (item.pod_doc == true) {
        this.getPODDetails(item.order_id).then((res) => {
          this.podList = res.data.pod_data;
          this.dialog = true;
        });
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
<style>
.title {
  padding: 20px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.custom-row .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.custom-row .v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.custom-row .v-input__slot {
  min-height: 50px !important;
}
.custom-row label.v-label.theme--light {
  top: 15px !important;
}
</style>
